// Utils
import { ternary } from "utils/ternary";

// Types
import { TeacherCreateMobileStep, ActivityType } from "store/interfaces/activity";
import { ValidationSchema } from "./activity-teacher-create.schema";

export const getMobileStepData = (mobileStep: TeacherCreateMobileStep) => {
    const mobileStepIndex = ternary([
        [mobileStep === "activity-class-data", 0],
        [mobileStep === "activity-type-data", 1],
        [mobileStep === "activity-answer-data", 2],
        [mobileStep === "activity-files-data", 3]
    ]) as number;

    const mobileStepDescription = ternary([
        [
            mobileStep === "activity-class-data",
            "Selecione uma ou mais turmas, incluindo o prazo de entrega da atividade. Você também pode de forma opcional informar uma data para liberar a atividade."
        ],
        [mobileStep === "activity-type-data", "Selecione o tipo de atividade."],
        [mobileStep === "activity-answer-data", "Preencha os campos abaixo com as informações complementares"],
        [mobileStep === "activity-files-data", "Utilize essa etapa de forma opcional, caso queira adicionar um material de apoio."]
    ]) as string;

    return { mobileStepIndex, mobileStepDescription };
};

export const getMobileStep = (mobileStep: TeacherCreateMobileStep, type: "previous" | "next") => {
    if (type === "previous") {
        return ternary<TeacherCreateMobileStep>([
            [mobileStep === "activity-type-data", "activity-class-data"],
            [mobileStep === "activity-answer-data", "activity-type-data"],
            [mobileStep === "activity-files-data", "activity-answer-data"]
        ]);
    }

    return ternary<TeacherCreateMobileStep>([
        [mobileStep === "activity-class-data", "activity-type-data"],
        [mobileStep === "activity-type-data", "activity-answer-data"],
        [mobileStep === "activity-answer-data", "activity-files-data"]
    ]);
};

export const getMobileStepError = (mobileStep: TeacherCreateMobileStep, mobileFormData: ValidationSchema, formActivityType?: ActivityType) => {
    const stepsWithValidations = [
        {
            step: "activity-class-data",
            validations: [
                {
                    shouldTrigger: !mobileFormData?.mainData?.classes?.length,
                    trigger: "mainData.classes"
                },
                {
                    shouldTrigger: !mobileFormData?.mainData?.releaseDate,
                    trigger: "mainData.releaseDate"
                }
            ]
        },
        {
            step: "activity-type-data",
            validations: [
                {
                    shouldTrigger: !mobileFormData?.activityType?.data,
                    trigger: "activityType.data"
                },
                {
                    shouldTrigger: mobileFormData?.activityType?.data === "exercise-list" && !mobileFormData?.activityType?.exerciseListType,
                    trigger: "activityType.exerciseListType"
                }
            ]
        },
        {
            step: "activity-answer-data",
            validations: [
                {
                    shouldTrigger: !mobileFormData?.generalInformations?.title,
                    trigger: "generalInformations.title"
                },
                {
                    shouldTrigger: !mobileFormData?.generalInformations?.enunciation,
                    trigger: "generalInformations.enunciation"
                },
                {
                    shouldTrigger:
                        formActivityType === "exercise-list" &&
                        mobileFormData?.activityType?.exerciseListType === "pre-created" &&
                        !mobileFormData?.exerciseListInformations?.questionsBankExerciseListId,
                    trigger: "exerciseListInformations.questionsBankExerciseListId"
                },
                {
                    shouldTrigger:
                        formActivityType === "exercise-list" &&
                        mobileFormData?.activityType?.exerciseListType === "custom" &&
                        (!mobileFormData?.questions || mobileFormData?.questions < 1),
                    trigger: "questions"
                },
                {
                    shouldTrigger: formActivityType === "send-file" && !mobileFormData?.sendFileInformations?.allowedFileTypes?.length,
                    trigger: "sendFileInformations.allowedFileTypes"
                }
            ]
        }
    ];

    const currentStepValidations = stepsWithValidations.find((item) => item.step === mobileStep);

    if (!currentStepValidations) {
        return undefined;
    }

    const errorValidation = currentStepValidations.validations.find((validation) => !!validation.shouldTrigger);

    if (!!errorValidation) {
        return errorValidation.trigger;
    }

    return undefined;
};

export const getActivityDropdownPlaceholder = (optionsLength: number) => {
    return ternary([
        [optionsLength === 0, "Selecionar turma"],
        [optionsLength === 1, "1 selecionado"],
        [optionsLength > 1, `${optionsLength} selecionados`]
    ]);
};
